import React, { useState, useEffect, useRef } from 'react'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import { CFormCheck, CFormLabel } from '@coreui/react'
import Select from 'react-select'
import { isSameDay } from 'date-fns'
import { Calendar } from 'lucide-react'

const CustomDatePicker = ({ allowedDates, providers, daysMap, locations, selectedDate, selectedProvider, onDateChange, onProviderChange, facilityDays, isInFacility, accordionState, selectedIsInFacility }) => {
  const wrapperRef = useRef(null)
  const datepickerRef = useRef(null)
  const [allDayData, setAllDayData] = useState([])
  const [isOpen, setIsOpen] = useState(false)
  useEffect(() => {
    if (selectedDate) {
      const dayOptions = { weekday: 'long' }
      const day = selectedDate.toLocaleDateString('en-US', dayOptions)
      try {
        const dayData = daysMap[day] || []
        const allDay = dayData.map((obj) => {
          obj.Facilities.forEach((facility) => {
            const tempFacility = locations.find((o) => o.ID === facility.FacilityID)
            facility['Name'] = tempFacility?.Name || ''
            facility['Type'] = tempFacility?.Type || ''
          })

          return obj
        })

        const availableProviders = allDay
          .map((provider) => {
            const matchedFacility = provider.Facilities.find((facility) => parseInt(facility.FacilityID) === facilityDays.ID)
            if (matchedFacility) {
              return {
                ...provider,
                MatchedFacility: matchedFacility,
              }
            }
            return null
          })
          .filter(Boolean) // removes nulls

        setAllDayData(availableProviders)
      } catch (e) {
        alert('No data for this day.')
      }
    }
  }, [selectedDate, daysMap, locations])
  const isDateAllowed = (date) => {
    return allowedDates.some((allowedDate) => isSameDay(allowedDate, date))
  }

  const toggleCalendar = () => {
    setIsOpen((prev) => !prev)
  }

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  return (
    <div className="d-flex flex-column gap-3" style={{ width: '100%' }} ref={wrapperRef}>
      {/* Date Picker Section */}
      <div>
        <CFormLabel>Select Date</CFormLabel>
        <div className="datepicker-wrapper datepicker-wrapper--dark" style={{ position: 'relative', display: 'block', width: '300px' }}>
          <DatePicker
            ref={datepickerRef}
            selected={selectedDate}
            onChange={(date) => {
              onDateChange(date)
              setIsOpen(false)
            }}
            onInputClick={toggleCalendar}
            filterDate={isDateAllowed}
            placeholderText="Select a date"
            highlightDates={allowedDates}
            open={isOpen}
            shouldCloseOnSelect={true}
            className="form-control pe-5 custom-datepicker-input"
            dateFormat="MM/dd/yyyy"
          />
          <Calendar
            onClick={toggleCalendar}
            size={18}
            title="Toggle calendar"
            style={{
              position: 'absolute',
              top: '50%',
              right: '12px',
              transform: 'translateY(-50%)',
              cursor: 'pointer',
              color: '#555',
              pointerEvents: 'auto',
            }}
          />
        </div>
      </div>

      {/* Provider Dropdown */}
      <div>
        <CFormLabel>Select Provider</CFormLabel>
        <div style={{ maxWidth: '300px' }}>
          <Select options={allDayData.map((item) => ({ value: item.ID, label: item.Name }))} onChange={onProviderChange} value={selectedProvider || false} className="react-select-container" classNamePrefix="react-select" />
        </div>
      </div>

      {/* Checkbox */}
      <div>
        <CFormCheck id="patientFacilityCheckbox" label="Patient in Facility." checked={selectedIsInFacility || false} onChange={(e) => isInFacility(e.target.checked)} className="mt-2" />
      </div>
    </div>
  )
}

export default CustomDatePicker
